var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hide
    ? _c(
        "div",
        {
          staticClass: "input-field",
          style: [
            {
              width: _vm.inputFieldSize + "%",
              alignItems: _vm.alignLabel
            },
            _vm.inputFieldContainerStyling
          ]
        },
        [
          _vm.label
            ? _c(
                "label",
                {
                  staticClass: "form-label-div",
                  class: { disabled: _vm.disabled },
                  staticStyle: {
                    overflow: "hidden",
                    "white-space": "nowrap",
                    "text-overflow": "ellipsis",
                    "max-width": "90%"
                  }
                },
                [
                  _vm._v("\n    " + _vm._s(_vm.label)),
                  _vm.required ? _c("span", [_vm._v("*")]) : _vm._e(),
                  _vm.badLabel
                    ? _c("span", { staticClass: "errorLabel" }, [
                        _vm._v("Limit is: " + _vm._s(_vm.limit) + " ")
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-field-container" },
            [
              _c(
                "div",
                {
                  staticClass: "input-container",
                  style: { justifyContent: _vm.inputContainerAlign }
                },
                [
                  _vm.inputType === "text"
                    ? _c("input", {
                        class: {
                          "with-label-button": _vm.automaticLabel,
                          invalid: !_vm.isValid
                        },
                        style: _vm.inputStyle,
                        attrs: {
                          type: "text",
                          disabled:
                            _vm.disabled ||
                            (_vm.labelIsLocked &&
                              _vm.variableName.includes("_label")),
                          placeholder: _vm.placeholder,
                          id: _vm.fieldId
                        },
                        domProps: { value: _vm.value },
                        on: {
                          input: function($event) {
                            return _vm.updateValue($event.target.value)
                          },
                          keypress: function($event) {
                            _vm.restrictSpecialCharacters
                              ? _vm.nameKeydown($event)
                              : _vm.checkAlphanumeric($event)
                          }
                        }
                      })
                    : _vm.inputType === "password"
                    ? _c("input", {
                        class: {
                          invalid: !_vm.isValid
                        },
                        style: _vm.inputStyle,
                        attrs: {
                          type: "password",
                          disabled: _vm.disabled,
                          autocomplete: "new_password",
                          minlength: 8
                        },
                        domProps: { value: _vm.value },
                        on: {
                          input: function($event) {
                            return _vm.updateValue($event.target.value)
                          }
                        }
                      })
                    : _vm.inputType === "textarea"
                    ? _c("textarea", {
                        class: {
                          invalid: !_vm.isValid
                        },
                        style: _vm.inputStyle,
                        attrs: { type: "textarea", disabled: _vm.disabled },
                        domProps: { value: _vm.value },
                        on: {
                          input: function($event) {
                            return _vm.updateValue($event.target.value)
                          }
                        }
                      })
                    : _vm.inputType === "email"
                    ? _c("input", {
                        style: _vm.inputStyle,
                        attrs: {
                          type: "email",
                          disabled: _vm.disabled,
                          placeholder: _vm.placeholder,
                          id: _vm.fieldId
                        },
                        domProps: { value: _vm.value },
                        on: {
                          input: function($event) {
                            return _vm.updateValue($event.target.value)
                          }
                        }
                      })
                    : _vm.inputType === "checkbox"
                    ? _vm._l(_vm.checkboxOptions, function(checkbox) {
                        return _c(
                          "div",
                          { key: checkbox.id, style: { padding: "0 0 0 1px" } },
                          [
                            _c("custom-checkbox", {
                              attrs: {
                                value: _vm.value,
                                label: checkbox.label,
                                disabled: _vm.disabled,
                                height: _vm.height,
                                width: _vm.width,
                                border: _vm.border,
                                "checkbox-style": _vm.inputStyle,
                                checkboxLabelStyle: _vm.checkboxLabelStyle,
                                "checkbox-icon-style": _vm.checkboxIconStyle,
                                indeterminate: _vm.indeterminate
                              },
                              on: {
                                "update-value": function($event) {
                                  return _vm.updateValue(!_vm.value)
                                }
                              }
                            })
                          ],
                          1
                        )
                      })
                    : _vm.inputType === "number" ||
                      _vm.inputType === "int" ||
                      _vm.inputType === "float" ||
                      _vm.inputType === "int_pos" ||
                      _vm.inputType === "float_pos" ||
                      _vm.inputType === "number_pos"
                    ? _c("input", {
                        class: {
                          invalid: !_vm.isValid
                        },
                        style: _vm.inputStyle,
                        attrs: {
                          type: "number",
                          disabled: _vm.disabled,
                          placeholder: _vm.placeholder,
                          min: _vm.min,
                          max: _vm.max,
                          step: _vm.step ? _vm.step : _vm.autoNumberFieldStep,
                          id: _vm.fieldId
                        },
                        domProps: { value: _vm.value },
                        on: {
                          input: function($event) {
                            return _vm.updateValue($event.target.value)
                          },
                          keypress: _vm.checkInput
                        }
                      })
                    : _vm.inputType === "select" ||
                      _vm.inputType === "multi-select" ||
                      _vm.inputType === "multiselect"
                    ? _c("treeselect", {
                        staticClass: "form-input-select",
                        style: _vm.inputStyle,
                        attrs: {
                          disableFuzzyMatching: "",
                          appendToBody: "",
                          value: _vm.value,
                          options: _vm.selectOptionsList
                            ? _vm.selectOptionsList
                            : _vm.options,
                          "load-options": _vm.loadOptions,
                          normalizer: _vm.normalizer,
                          multiple:
                            _vm.inputType === "multi-select" ||
                            _vm.inputType === "multiselect",
                          placeholder: _vm.treeSelectPlaceHolder
                            ? _vm.treeSelectPlaceHolder
                            : _vm.selectPlaceholder,
                          disabled: _vm.disabled,
                          clearable: _vm.clearable,
                          disableBranchNodes: _vm.disableBranchNodes
                        },
                        on: {
                          input: function($event) {
                            return _vm.updateValue($event)
                          }
                        }
                      })
                    : _vm.inputType === "user"
                    ? _c("treeselect", {
                        staticClass: "form-input-select",
                        style: _vm.inputStyle,
                        attrs: {
                          disableFuzzyMatching: "",
                          value: _vm.value,
                          options: _vm.options,
                          "load-options": _vm.loadUserOptions,
                          normalizer: _vm.userNormalizer,
                          placeholder: _vm.placeholder,
                          disabled: _vm.disabled,
                          clearable: _vm.clearable
                        },
                        on: {
                          input: function($event) {
                            return _vm.updateValue($event)
                          }
                        }
                      })
                    : _vm.inputType === "radio"
                    ? _c(
                        "v-radio-group",
                        {
                          staticClass: "radio-input",
                          style: _vm.inputStyle,
                          attrs: {
                            id: "radio-buttons",
                            value: _vm.value,
                            "input-value": _vm.value,
                            column: _vm.radioInColumn,
                            "hide-details": true
                          },
                          on: {
                            change: function($event) {
                              return _vm.updateValue($event)
                            }
                          }
                        },
                        _vm._l(_vm.radioOptions, function(option) {
                          return _c("v-radio", {
                            key: option.label,
                            attrs: {
                              color: _vm.inputFieldColor,
                              label: option.label,
                              value: _vm.convertedValue(option.value),
                              ripple: false,
                              disabled: _vm.disabled
                            }
                          })
                        }),
                        1
                      )
                    : _vm.inputType === "url"
                    ? _c("div", { staticClass: "url" }, [
                        _vm.disabled && _vm.value
                          ? _c(
                              "a",
                              {
                                staticClass: "accent--text",
                                staticStyle: { "background-color": "white" },
                                attrs: {
                                  href: _vm.getValidURL(_vm.value),
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.value) +
                                    "\n        "
                                )
                              ]
                            )
                          : _c("input", {
                              style: _vm.inputStyle,
                              attrs: {
                                type: "text",
                                disabled: _vm.disabled,
                                placeholder: _vm.placeholder
                              },
                              domProps: { value: _vm.value },
                              on: {
                                input: function($event) {
                                  return _vm.updateValue($event.target.value)
                                }
                              }
                            })
                      ])
                    : _vm.inputType === "date"
                    ? _c(
                        "div",
                        { staticClass: "date" },
                        [
                          _c("input", {
                            style: _vm.inputStyle,
                            attrs: { type: "date", disabled: _vm.disabled },
                            domProps: { value: _vm.getDate },
                            on: {
                              input: function($event) {
                                return _vm.updateValue($event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          !_vm.disabled && !_vm.required && _vm.value
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "form-input-clear-button",
                                  attrs: { "x-small": "", text: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateValue(null)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { size: "15" } }, [
                                    _vm._v("\n            clear\n          ")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm.inputType === "datetime"
                    ? _c(
                        "div",
                        { staticClass: "datetime" },
                        [
                          _c("input", {
                            staticStyle: { width: "100%" },
                            style: _vm.inputStyle,
                            attrs: {
                              type: "datetime-local",
                              disabled: _vm.disabled,
                              min: _vm.min,
                              max: _vm.max,
                              step: _vm.step
                            },
                            domProps: { value: _vm.dateTimeValue },
                            on: {
                              change: function($event) {
                                return _vm.setDateTimeValue($event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          !_vm.disabled && !_vm.required && _vm.value
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "form-input-clear-button",
                                  attrs: { "x-small": "", text: "", icon: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateValue(null)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { size: "15" } }, [
                                    _vm._v("\n            clear\n          ")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm.inputType === "file"
                    ? _c("drop-file-area", {
                        ref: "dropFileInput",
                        attrs: {
                          disabled: _vm.disabled,
                          "file-types": _vm.fileTypes,
                          "multiple-files": _vm.multipleFiles
                        },
                        on: {
                          updateFile: function($event) {
                            return _vm.updateValue($event)
                          },
                          trashFile: function($event) {
                            return _vm.updateValue(null)
                          }
                        }
                      })
                    : _vm.inputType === "other"
                    ? _c(
                        "div",
                        {
                          staticClass: "input-container",
                          attrs: { disabled: _vm.disabled }
                        },
                        [_vm._t("default")],
                        2
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.fieldIsLabel
                ? _c(
                    "v-icon",
                    {
                      staticStyle: { color: "var(--v-accent-base)" },
                      attrs: { disabled: _vm.userCanUnlockLabel },
                      on: {
                        click: function($event) {
                          return _vm.$emit("toggle-label-lock")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.labelIsLocked ? "mdi-lock" : "mdi-lock-open"
                          ) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("front-slot")
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24acf19a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24acf19a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Atoms/InputField.vue
// module id = null
// module chunks = 